import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createPharmaSalesRetailerSlice = createAsyncThunk(
  "PharmaSalesRetailer/createPharmaSalesRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/PharmaSalesRetailer/createPharmaSalesRetailer",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllPharmaSalesRetailerSlice = createAsyncThunk(
  "PharmaSalesRetailer/getAllPharmaSalesRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/PharmaSalesRetailer/getAllPharmaSalesRetailer",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPharmaSalesRetailerByIdSlice = createAsyncThunk(
  "PharmaSalesRetailer/getPharmaSalesRetailerById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSalesRetailer/getPharmaSalesRetailerById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const updatePharmaSalesRetailerSlice = createAsyncThunk(
  "PharmaSalesRetailer/updatePharmaSalesRetailer",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/pharmaSalesRetailer/updatePharmaSalesRetailer",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const refundPharmaSalesRetailerSlice = createAsyncThunk(
  "PharmaSalesRetailer/refundPharmaSalesRetailerSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSalesRetailer/refundPharmaSalesRetailer",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const cancelPharmaSalesRetailerSlice = createAsyncThunk(
  "PharmaSalesRetailer/cancelPharmaSalesRetailerSlice",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSalesRetailer/cancelPharmaSalesRetailer",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getPharmaRetailerCollectionSlice = createAsyncThunk(
  "PharmaSalesRetailer/getPharmaRetailerCollection",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/pharmaSalesRetailer/getPharmaRetailerCollection",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const initialState = {
  pharmaSalesRetailer: [],
  pharmaSalesRetailerInfo: [],
  pharmaSalesRetailerCollection: [],
  isLoading: false,
  createPharmaSalesRetailerSuccessMessage: null,
  createPharmaSalesRetailerErrorMessage: null,
  updatePharmaSalesRetailerSuccessMessage: null,
  updatePharmaSalesRetailerErrorMessage: null,
  searchPharmaSalesRetailerErrorMessage: null,
  refundPharmaSalesRetailerSuccessMessage: null,
  refundPharmaSalesRetailerErrorMessage: null,
  cancelPharmaSalesRetailerSuccessMessage: null,
  cancelPharmaSalesRetailerErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const pharmaSalesRetailerSlice = createSlice({
  name: "pharmaSalesRetailer",
  initialState,
  reducers: {
    resetAddPharmaSalesRetailerMessage: (state) => {
      state.createPharmaSalesRetailerSuccessMessage = null;
      state.createPharmaSalesRetailerErrorMessage = null;
    },
    resetUpdatePharmaSalesRetailerMessage: (state) => {
      state.updatePharmaSalesRetailerSuccessMessage = null;
      state.updatePharmaSalesRetailerErrorMessage = null;
    },
    resetRefundPharmaSalesRetailerMessage: (state) => {
      state.refundPharmaSalesRetailerSuccessMessage = null;
      state.refundPharmaSalesRetailerErrorMessage = null;
    },
    resetCancelPharmaSalesRetailerMessage: (state) => {
      state.cancelPharmaSalesRetailerSuccessMessage = null;
      state.cancelPharmaSalesRetailerErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPharmaSalesRetailerSlice.pending, (state) => {
        state.isLoading = true;
        state.createPharmaSalesRetailerSuccessMessage = null;
        state.createPharmaSalesRetailerErrorMessage = null;
      })
      .addCase(createPharmaSalesRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createPharmaSalesRetailerErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.createPharmaSalesRetailerSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(createPharmaSalesRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllPharmaSalesRetailerSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPharmaSalesRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.pharmaSalesRetailer = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchPharmaSalesRetailerErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.pharmaSalesRetailer = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchPharmaSalesRetailerErrorMessage = null;
      })
      .addCase(getAllPharmaSalesRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSalesRetailerErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(getPharmaSalesRetailerByIdSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPharmaSalesRetailerByIdSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pharmaSalesRetailerInfo = action?.payload?.result?.list;
      })
      .addCase(getPharmaSalesRetailerByIdSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSalesRetailerErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(updatePharmaSalesRetailerSlice.pending, (state) => {
        state.isLoading = true;
        state.updatePharmaSalesRetailerSuccessMessage = null;
        state.updatePharmaSalesRetailerErrorMessage = null;
      })
      .addCase(updatePharmaSalesRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.updatePharmaSalesRetailerErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.updatePharmaSalesRetailerSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(updatePharmaSalesRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(refundPharmaSalesRetailerSlice.pending, (state) => {
        state.isLoading = true;
        state.refundPharmaSalesRetailerSuccessMessage = null;
        state.refundPharmaSalesRetailerErrorMessage = null;
      })
      .addCase(refundPharmaSalesRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.refundPharmaSalesRetailerErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.refundPharmaSalesRetailerSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(refundPharmaSalesRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(cancelPharmaSalesRetailerSlice.pending, (state) => {
        state.isLoading = true;
        state.cancelPharmaSalesRetailerSuccessMessage = null;
        state.cancelPharmaSalesRetailerErrorMessage = null;
      })
      .addCase(cancelPharmaSalesRetailerSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.cancelPharmaSalesRetailerErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.cancelPharmaSalesRetailerSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(cancelPharmaSalesRetailerSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getPharmaRetailerCollectionSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPharmaRetailerCollectionSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.searchPharmaSalesRetailerErrorMessage =
            action?.payload?.result?.message;
        }
        state.pharmaSalesRetailerCollection = action?.payload?.result?.list;
      })
      .addCase(getPharmaRetailerCollectionSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPharmaSalesRetailerErrorMessage =
          action?.payload?.result?.message;
      });
  },
});
export const {
  resetAddPharmaSalesRetailerMessage,
  resetUpdatePharmaSalesRetailerMessage,
  resetRefundPharmaSalesRetailerMessage,
  resetCancelPharmaSalesRetailerMessage,
} = pharmaSalesRetailerSlice.actions;

export default pharmaSalesRetailerSlice.reducer;
